// components/parametres/ConfigTab.js
import React, { useState, useEffect } from 'react';
import api from '../../services/api';

const ConfigTab = () => {
  const [form, setForm]             = useState({});
  const [chargement, setChargement] = useState(true);
  const [sauvegarde, setSauvegarde] = useState(false);
  const [message, setMessage]       = useState(null);

  const champs = [
    { cle: 'nom_societe',     label: 'Nom de la société',      type: 'text'   },
    { cle: 'adresse',         label: 'Adresse du siège',       type: 'text'   },
    { cle: 'telephone',       label: 'Téléphone',              type: 'text'   },
    { cle: 'email',           label: 'Email de contact',       type: 'email'  },
    { cle: 'tva_taux',        label: 'Taux de TVA (%)',        type: 'number' },
    { cle: 'exercice_fiscal', label: 'Exercice fiscal',        type: 'number' },
    { cle: 'devise',          label: 'Devise',                 type: 'text'   },
  ];

  useEffect(() => {
    const charger = async () => {
      try {
        const res = await api.get('/parametres/config');
        // res.data = { nom_societe: { valeur, description }, ... }
        const init = {};
        Object.keys(res.data).forEach(cle => {
          init[cle] = res.data[cle].valeur || '';
        });
        setForm(init);
      } catch (err) {
        setMessage({ type: 'erreur', texte: 'Erreur de chargement de la configuration.' });
      } finally {
        setChargement(false);
      }
    };
    charger();
  }, []);

  const handleChange = (cle, valeur) => {
    setForm(prev => ({ ...prev, [cle]: valeur }));
  };

  const sauvegarder = async () => {
    setSauvegarde(true);
    setMessage(null);
    try {
      const configs = Object.keys(form).map(cle => ({ cle, valeur: form[cle] }));
      await api.put('/parametres/config', { configs });
      setMessage({ type: 'succes', texte: 'Configuration sauvegardée avec succès !' });
    } catch (err) {
      setMessage({ type: 'erreur', texte: err.response?.data?.message || 'Erreur serveur.' });
    } finally {
      setSauvegarde(false);
    }
  };

  const styles = {
    container:  { background: 'white', borderRadius: 8, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', maxWidth: 680 },
    grid:       { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px 24px', marginBottom: 24 },
    group:      { display: 'flex', flexDirection: 'column', gap: 6 },
    label:      { fontSize: 13, fontWeight: 600, color: '#374151' },
    input:      { padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, color: '#111827', outline: 'none' },
    btnSave:    { padding: '10px 28px', background: '#1a5c2a', color: 'white', border: 'none', borderRadius: 6, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
    msgSucces:  { marginBottom: 20, padding: '10px 16px', background: '#d1fae5', color: '#065f46', borderRadius: 6, fontSize: 14 },
    msgErreur:  { marginBottom: 20, padding: '10px 16px', background: '#fee2e2', color: '#991b1b', borderRadius: 6, fontSize: 14 },
    divider:    { borderBottom: '1px solid #f3f4f6', marginBottom: 20 },
  };

  if (chargement) return <p style={{ color: '#6b7280', padding: 24 }}>Chargement...</p>;

  return (
    <div style={styles.container}>
      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 6, color: '#1a5c2a' }}>
        ⚙️ Configuration générale
      </h2>
      <p style={{ fontSize: 13, color: '#6b7280', marginBottom: 20 }}>
        Informations générales de la société et paramètres fiscaux.
      </p>
      <div style={styles.divider} />

      {message && (
        <div style={message.type === 'succes' ? styles.msgSucces : styles.msgErreur}>
          {message.texte}
        </div>
      )}

      <div style={styles.grid}>
        {champs.map(c => (
          <div key={c.cle} style={styles.group}>
            <label style={styles.label}>{c.label}</label>
            <input
              type={c.type}
              style={styles.input}
              value={form[c.cle] || ''}
              onChange={e => handleChange(c.cle, e.target.value)}
              placeholder={c.label}
            />
          </div>
        ))}
      </div>

      <button
        style={styles.btnSave}
        onClick={sauvegarder}
        disabled={sauvegarde}
      >
        {sauvegarde ? 'Sauvegarde...' : '💾 Sauvegarder la configuration'}
      </button>
    </div>
  );
};

export default ConfigTab;
